/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/

/* istanbul ignore file */
const config = {}
export default config

function load() {
  const newconfig = {
    VariableSettings: {
      BackOfficeAPIURL: process.env.BackOfficeAPIURL,
      AzureAdClientId: process.env.AzureAdClientId,
      AzureAdTenantId: process.env.AzureAdTenantId,
      BackOfficeUIURL: process.env.BackOfficeUIURL,
      LookupDataAPIURL: process.env.LookupDataAPIURL,
      PermissionDataAPIURL: process.env.PermissionDataAPIURL,
      WhiteLabelRestAPIURL: process.env.WhiteLabelRestAPIURL,
      PurgeRestAPIURL: process.env.PurgeRestAPIURL,
      CEOLiveTrackingAPIURL: process.env.CEOLiveTrackingAPIURL,
      MapsRouteValue: process.env.MapsRouteValue,
      PowerBIWorkSpaceId: process.env.PowerBIWorkSpaceId,
      PowerBIOpenWorkflowOverviewReportId:
        process.env.PowerBIOpenWorkflowOverviewReportId,
      PowerBIApprovalQueueReportId: process.env.PowerBIApprovalQueueReportId,
      PowerBIPrintDetailandPrintOverviewReportId:
        process.env.PowerBIPrintDetailandPrintOverviewReportId,
      PowerBILetterProducedDetailReportId:
        process.env.PowerBILetterProducedDetailReportId,
      PowerBIHoldReportId: process.env.PowerBIHoldReportId,
      PowerBIOperationalExternalReportId:
        process.env.PowerBIOperationalExternalReportId,
      PowerBIDFTReportId: process.env.PowerBIDFTReportId,
      PowerBIPaymentReportId: process.env.PowerBIPaymentReportId,
      PowerBIRefundsChargebacksReportId:
        process.env.PowerBIRefundsChargebacksReportId,
      PowerBITransferReportId: process.env.PowerBITransferReportId,
      PowerBIManualDiscountReportId: process.env.PowerBIManualDiscountReportId,
      PowerBIOnStreetLogReportId: process.env.PowerBIOnStreetLogReportId,
      TFLOnStreetLogReportID: process.env.TFLOnStreetLogReportID,
      PowerBIUserActivityReportId: process.env.PowerBIUserActivityReportId,
      PowerBIParseqScansReportId: process.env.PowerBIParseqScansReportId,
      PowerBICCTVCaseOverviewReportId:
        process.env.PowerBICCTVCaseOverviewReportId,
      PowerBIRevenueReportReportId: process.env.PowerBIRevenueReportReportId,
      PowerBICorrespondencePrintingReportId:
        process.env.PowerBICorrespondencePrintingReportId,
      PowerBIPersistentEvadersReportId:
        process.env.PowerBIPersistentEvadersReportId,
      PowerBIRevenuePerLocationReportId:
        process.env.PowerBIRevenuePerLocationReportId,
      PowerBICEOTrackingReportId: process.env.PowerBICEOTrackingReportId,
      TFLCEOTrackingReportID: process.env.TFLCEOTrackingReportID,
      PowerBICEOActivityDetailReportId:
        process.env.PowerBICEOActivityDetailReportId,
      TFLCEOActivityDetailReportID: process.env.TFLCEOActivityDetailReportID,
      HHDCasesOverviewReportId: process.env.HHDCasesOverviewReportId,
      PrefixAuditReportId: process.env.PrefixAuditReportId,
      CEOHoursPatrolledbyLocationReportId:
        process.env.CEOHoursPatrolledbyLocationReportId,
      TFLCEOHoursPatrolledbyLocationReportID:
        process.env.TFLCEOHoursPatrolledbyLocationReportID,
      B2CClientID: process.env.B2CClientID,
      B2CAuthority: process.env.B2CAuthority,
      B2CAuthorityCommon: process.env.B2CAuthorityCommon,
      B2CPolicyNameLocal: process.env.B2CPolicyNameLocal,
      B2CPolicyNameCustom: process.env.B2CPolicyNameCustom,
      OCRWebHookURL: process.env.OCRWebHookURL,
      MobileHubURL: process.env.MobileHubURL,
      PowerBICancellationReportId: process.env.PowerBICancellationReportId,
      ApplicationInsightsModuleLogValue:
        process.env.ApplicationInsightsModuleLogValue,
      MonitoringDashboardReportId: process.env.MonitoringDashboardReportId,
      CasesNotProgressedReportId: process.env.CasesNotProgressedReportId,
      PcnForecastReportId: process.env.PcnForecastReportId,
      CasesOnHoldAndNextProgressionReportId:
        process.env.CasesOnHoldAndNextProgressionReportId,
      CaseActiveDaysReportId: process.env.CaseActiveDaysReportId,
      PrintBatchesReportId: process.env.PrintBatchesReportId,
      BailiffBatchesReportId: process.env.BailiffBatchesReportId,
      BackOfficersReportId: process.env.BackOfficersReportId,
      EnforcementOfficersReportId: process.env.EnforcementOfficersReportId,
      PowerBILettersSentReportId: process.env.PowerBILettersSentReportId,
      PowerBICEOHeatmapReportId: process.env.PowerBICEOHeatmapReportId,
      PowerBIContractStats: process.env.PowerBIContractStats,
      PowerBIOnStreetActivitiesSummaryReportId:
        process.env.PowerBIOnStreetActivitiesSummaryReportId,
      TFLOnStreetActivitiesSummaryReportID:
        process.env.TFLOnStreetActivitiesSummaryReportID,
      BackOfficeIntegrationServiceAPIURL:
        process.env.BackOfficeIntegrationServiceAPIURL,
      JobsReportID: process.env.JobsReportID,
      DailyPaymentReportID: process.env.DailyPaymentReportID,
      ImpoundReportID: process.env.ImpoundReportID,
      JobPoundOverviewReportID: process.env.JobPoundOverviewReportID,
      PowerBIPCNsIssuedbyTypeReportId:
        process.env.PowerBIPCNsIssuedbyTypeReportId,
      OfficerAccuracyMonitoringReportId:
        process.env.OfficerAccuracyMonitoringReportId,
      CaseTypeReportId: process.env.CaseTypeReportId,
      PowerBIPersistentEvadersatEAReportId:
        process.env.PowerBIPersistentEvadersatEAReportId,
      ChallengeandRepOutcomesReportId:
        process.env.ChallengeandRepOutcomesReportId,
      BurndownReportId: process.env.BurndownReportId,
      HotspotReportId: process.env.HotspotReportId,
      MuiGridLicenseKey: process.env.MuiGridLicenseKey,
      HHDSyncReportId: process.env.HHDSyncReportId,
      PermitsRestAPIURL: process.env.PermitsRestAPIURL,
      AllCasesReportId: process.env.AllCasesReportId,
      AIRAMasterDataCountReportID: process.env.AIRAMasterDataCountReportID,
      AIRAUsageReportID: process.env.AIRAUsageReportID,
      AIRAUserJourneyReportID: process.env.AIRAUserJourneyReportID,
      PCNandRevenueReportId: process.env.PCNandRevenueReportId,
      AllCCTVCasesReportID: process.env.AllCCTVCasesReportID,
      TimePayReportID: process.env.TimePayReportID,
      InvoicingDataReportID: process.env.InvoicingDataReportID,
      AccountingReportID: process.env.AccountingReportID,
      DVLAReportID: process.env.DVLAReportID,
      SchoolReportID: process.env.SchoolReportID,
      PermissionChecksReportID: process.env.PermissionChecksReportID,
      SchoolEnforcementReportID: process.env.SchoolEnforcementReportID,
      InboundEmailsReportID: process.env.InboundEmailsReportID,
      PasscodeKey: process.env.PasscodeKey,
      FPNOverviewReportID: process.env.FPNOverviewReportID,
      PCNOverviewReportID: process.env.PCNOverviewReportID,
      CaseKeeperDetailsReportID: process.env.CaseKeeperDetailsReportID,
      CaseKeeperDetailsReportID: process.env.CaseKeeperDetailsReportID,
      CaseReportReportId: process.env.CaseReportReportId,
      ObservationsReportID: process.env.ObservationsReportID,
      OnStreetActivitiesExtendedReportID:
        process.env.OnStreetActivitiesExtendedReportID,
      ObservationsReportID: process.env.ObservationsReportID,
      SyncfusionLicenseKey: process.env.SyncfusionLicenseKey,
      PrivateLandAPIURL: process.env.PrivateLandAPIURL,
      CaseProgressionReportID: process.env.CaseProgressionReportID,
      summarizationCoreDataUIURL: process.env.summarizationCoreDataUIURL,
      OfficerBreaksReportID: process.env.OfficerBreaksReportID,
      FaultsReportID: process.env.FaultsReportID,
      LGKPIReportID: process.env.LGKPIReportID,
      MonthlyReviewReportID: process.env.MonthlyReviewReportID,
      ANPROperationalPerformanceReportID:
        process.env.ANPROperationalPerformanceReportID,
      AbandonedVehiclesReportID: process.env.AbandonedVehiclesReportID,
      SiteChallengeandRepOutcomesReportID:
        process.env.SiteChallengeandRepOutcomesReportID,
      DebtReportID: process.env.DebtReportID,
      WarrantReportID: process.env.WarrantReportID,
    },
  }
  for (const prop in config) {
    delete config[prop]
  }
  for (const prop in newconfig) {
    config[prop] = newconfig[prop]
  }
  return config
}
export { load }
